import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import $ from 'jquery';
import 'jquery-ui/ui/widgets/datepicker';
import ControlHeader from '../Basic/ControlHeader';

class DatePicker extends React.Component {
  constructor(props) {
    super(props);
    if (props.value)//if store has value relative to this component, initialize the state value
      this.state = { value: props.value, error: "" };
    else//in case the store does not have any value for this component, just clear it
      this.state = { value: "", error: "" };
  }
  componentDidMount() {
    const p = this.props;
    const id = p.id || p.name;
    if (id) {
      if (p.isOffRamp) {
        let daysInMilliSeconds = 1.814e+9; // default
        if (window.osa.requiredByDateOffsetDays) {
          daysInMilliSeconds = window.osa.requiredByDateOffsetDays * 8.64e+7;
        }
        $(`#${id}`).datepicker({
          showButtonPanel: false,
          changeYear: false,
          changeMonth: false,
          dateFormat: 'yy/mm/dd',
          defaultDate: new Date(),
          beforeShowDay: $.datepicker.noWeekends,
          minDate: new Date(+new Date + daysInMilliSeconds), // add 3 weeks (in milliseconds)
          onSelect: (dateText) => { this.updateStore(dateText); }
        });
      }
      else {
        $(`#${id}`).datepicker({
          showButtonPanel: false,
          changeYear: true,
          changeMonth: true,
          dateFormat: 'yy/mm/dd',
          defaultDate: new Date(1975, 0, 1),
          maxDate: new Date(),
          yearRange: '1920:2077',
          //yearRange: 'c-50:c+50'
          onSelect: (dateText) => { this.updateStore(dateText); }
        });
      }

      $(`#${id}`).addClass('hasDatepicker');
    }
  }
  componentWillReceiveProps(props) {
    if (props.value && props.value !== this.state.value)//if store's value relative to this component change, update the state value
      this.setState({ value: props.value });
    else if (!props.value)//in case the store does not have any value for this component, just clear it
      this.setState({ value: "" });
    if (props.error && props.error !== this.state.error)
      this.setState({ error: props.error });
  }
  componentWillUnmount() {
    const id = this.props.id || this.props.name;
    if (id)
      $(`#${id}`).datepicker('destroy');
  }
  change = e => {
    this.setState({ value: e.target.value });
  }
  blur = e => {
    this.updateStore(e.target.value);
   const p = this.props;
    const isSearchBp =  (p.name == 'accountHolderInfo_residentInfo_dob');
    if(isSearchBp)
       p.dispatch({ type: 'SET_SEARCH_BP_CALLED', value: false });
  }
  updateStore(value) {
    const p = this.props;
    const error = this.validate(value);
    this.setState({ value, error });
    this.props.dispatch({ type: 'textbox', name: p.name, value: value });
  }
  //pattern={}
  validate(value) {
    const p = this.props;
    const pattern = p.pattern || (/^(\d{4})(\/)(\d{1,2})(\/)(\d{1,2})$/g);
    let error = null;
    if (!value && p.required)
      error = p.errorMsg ? p.errorMsg : p.title + ' is required';
    if (value) {
      let patt = new RegExp(pattern);
      if (!patt.test(value))
        error = p.patternErrorMsg ? p.patternErrorMsg : p.title + ' is invalid';
    }
    return error;
  }
  render() {
    const p = this.props;
    const s = this.state || {};
      const isDisable = p.allowDOBEdit ? false : p.disabled;
    const className = isDisable ? "form-control dateDisabled": "form-control";
   
    const input = (<input type="text" id={p.id || p.name} name={p.name} value={s.value} className={className}
      onChange={this.change} onBlur={this.blur} placeholder={p.placeholder} disabled={isDisable}
      readOnly={p.readOnly} />); {/*for style part: in case that the text box is readonly, it should not show stop sign for cursor, just for disable condition*/ }
    return (
      <div className={s.error ? 'has-error' : ''}>
        <ControlHeader {...p} />
        {p.customClass ?
          <div className="row"><div className={p.customClass}>{input}</div></div>
          :
          <div>{input}</div>
        }
        {s.error ? <label className="control-label has-error validationMessage">{s.error}</label> : null}
      </div>
    );
  }
}

DatePicker.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  isOffRamp: PropTypes.bool,
  value: PropTypes.string,
  error: PropTypes.string,
  errorMsg: PropTypes.string,
  patternErrorMsg: PropTypes.string,
  dispatch: PropTypes.func,
};
const mapStateToProps = (state, props) => {
  return {
    value: state.form && state.form[props.name],
    error: state.form && state.form.errors && state.form.errors[props.name]
  };
};
export default connect(mapStateToProps)(DatePicker);